/** Id du texte d'aide d'un champ, pour son aria-describedby */
export const fieldHintId = (id: string) => `${id}-hint`;

/** Bordure, focus et état désactivé communs aux listes déroulantes et zones de texte des formulaires */
export const controlClassName =
  'w-full px-3 border border-slate-300 rounded-lg text-sm bg-card text-slate-700 outline-none focus-visible:border-blue-500 focus-visible:ring-[3px] focus-visible:ring-blue-500/30 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed';
